import React from 'react'
import nodata from '../../assets/images/nodata.svg';
const NoData = ({text}) => {
  return (
    <div className='flex items-center justify-center w-full min-h-[25vh]'>
          <div className=''>
            <img src={nodata} width={100} alt="No Data" className='m-auto'></img>
            <p className='text-base font-medium text-whiteText'>{text || "No Data Available"}</p>
          </div>
        </div>
  )
}

export default NoData